module.exports = __webpack_public_path__ + "static/img/16.4b101f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/16.png
// module id = KWaS
// module chunks = 0